// src/components/Loading.jsx
import React from "react";
import loadingVideo from "../assets/loadingCars.mp4";   // ← correct import
import "./Loading.css";
import logo from "../assets/trustauto-logo.png";

export const Loading = () => {
  return (
    <div className="loading-overlay">
      <img src={logo} alt="" className="logo-loading"/>
   <div className="loading-effect">
      {/* ---------- VIDEO ---------- */}
      <video
        className="loading-car"
        src={loadingVideo}
        autoPlay
        muted
        loop
        playsInline               // ← important for iOS
        preload="auto"
      >
        {/* Fallback for browsers that don’t support <video> */}
        <img
          src="/fallback-loading.gif"   // optional static fallback
          alt="Loading"
          style={{ width: "50%", height: "auto" }}
        />
      </video>

      {/* ---------- TEXT ---------- */}
   
      </div>
         <p className="loading-text">
        Loading<span className="dots"></span>
          
      </p>
    </div>
  );
};